import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import Slider from '../../components/slider';
import { useProjectByUuid } from '../../hooks/use-projects';

import styles from './sample-projects.module.scss';

export const SampleProjects = ({ data }) => (
	<div className={styles.wrapper}>
		<div className={styles.container}>
			<h2>{data.header}</h2>
			<div className={styles.items}>
				<Slider dots={true} className={styles.slider}>
					{data.items.map((uuid, key) => (
						<Item key={key} uuid={uuid} />
					))}
				</Slider>
			</div>

			<Link to={data.link.url} className={styles.button}>
				{data.link.label}
			</Link>
		</div>
	</div>
);

SampleProjects.defaultProps = {
	data: {},
};

SampleProjects.propTypes = {
	data: PropTypes.object.isRequired,
};

const Item = ({ uuid }) => {
	const project = useProjectByUuid(uuid);

	return (
		<Link to={project.slug} className={styles.item}>
			{project.image.file && (
				<div className={styles.image}>
					<GatsbyImage
						alt={project.image.alt}
						title={project.image.title}
						image={project.image.file.childImageSharp.gatsbyImageDataFluid}
					/>
				</div>
			)}

			<div className={styles.caption}>
				<h3 className={styles.title}>{project.name}</h3>
				<div>{project.summary}</div>
			</div>
		</Link>
	);
};

Item.defaultProps = {
	uuid: null,
};

Item.propTypes = {
	uuid: PropTypes.string.isRequired,
};
